<template>
  <no-data url="design/placeholder/zhanweilogo%402x.jpg!width_250px"></no-data>
</template>
<script>
import NoData from "./NoData";
export default {
  name: 'DefaultComp',
  components: { NoData },
};
</script>